<template>
  <div class="signup-container">
    <div class="signup-form">
      <h1 class="signup-title">Create an Account</h1>
      <form @submit.prevent="signup">
        <div class="input-container">
          <input type="text" id="first_name" v-model="first_name" placeholder="First name" required>
        </div>
        <div class="input-container">
          <input type="text" id="surname" v-model="surname" placeholder="Surname" required>
        </div>
        <div class="input-container">
          <input type="email" id="email" v-model="email" @blur="validateEmail"  placeholder="Email" required>
          <p v-if="emailError" class="error">{{ emailError }}</p>
        </div>
        <div class="input-container">
          <input type="password" id="password" v-model="password" @blur="validatePassword" placeholder="Password" required>
          <p v-if="passwordError" class="error">{{ passwordError }}</p>
        </div>
        <div class="button-container">
          <button type="submit" :style="{ backgroundColor: button_background_colour, color: button_text_colour }" class="signup-button">Register</button>
        </div>
        <div class="login-link">
          <p><a @click="backToLogin" class="login-link"> Already a member? Login</a></p>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      first_name: '',
      surname: '',
      email: '',
      password: '',
      button_background_colour: "",
      button_text_colour: "",
      emailError: null,
      passwordError: null,
    };
  },
  methods: {
  ...mapActions({
      signUpUser: "signUpUser",
      fetchIframeProperties: "fetchIframeProperties",
    }),
    validateEmail() {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (!emailPattern.test(this.email)) {
        this.emailError = 'Invalid email address';
      } else {
        this.emailError = null;
      }
    },
    validatePassword() {
      // Password must contain at least one lowercase letter, one uppercase letter,
      // one special character, one numeric character, and be at least 8 characters long.
      const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#?!@$%^&*-])[A-Za-z\d#?!@$%^&*-]{8,}$/;
      if (!passwordPattern.test(this.password)) {
        this.passwordError = `Your password must be at least 8 characters long and include at least one 
                uppercase letter, one lowercase letter, one number and one special character from the 
                following: # ? ! @ $ % ^ & * - `;
      } else {
        this.passwordError = null;
      }
    },
    showToast(msg, severity= "success", lifeTime = 2500) {
      let tconfig = {
        summary: msg,
        severity: severity,
      };
      if (lifeTime) {
        tconfig["life"] = lifeTime;
      }
      this.$toast.add(tconfig);
    },
    async signup() {
     this.validateEmail();
     this.validatePassword();
     if (!this.emailError && !this.passwordError) {
          let payload = {
            first_name: this.first_name,
            surname: this.surname,
            email: this.email,
            password: this.password
          }
          try{
              const resp = await this.signUpUser(payload)
              if (resp && resp.status == 200) {
                this.showToast("Yay! You're successfully registered.");
                this.$router.push({ name: 'Login' });
              } else {
                 this.showToast(resp.email.detail, "error")
              }
          }catch(error){
             this.showToast("Error in creating new user. Please check after sometime.", "error")
          }
     }
    },
    backToLogin() {
      this.$router.push({ name: 'Login' });
    },
    async fetchInitialInformation(){
      const resp = await this.fetchIframeProperties()
      if(resp){
        this.button_background_colour = resp.data.button_background_colour
        this.button_text_colour = resp.data.button_text_colour
      }
    }
  },
  async mounted() {
    await this.fetchInitialInformation()
  }
};
</script>

<style scoped>

.error{
  color: red;
}
.signup-container {
  display: flex;
  justify-content: center;
  align-items: center;
  content: fit;
  min-height: 100vh;
  background-color: transparent;
  /* background-image: url('https://www.cloudcix.com/assets/img/CLOUD_CIX_I4_.png');
  background-size: cover; */
}

.signup-form {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  padding: 30px;
  width: 350px;
  text-align: center;
}

.signup-title {
  font-size: 28px;
  margin-bottom: 20px;
  color: #333;
}

.input-container {
  display: flex;
  flex-direction: column;
  padding: 10px;
}

input {
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  outline: none;
  width: 90%;
}

input:focus {
  outline: none;
  border-color: black;
}

.signup-button {
  border: none;
  border-radius: 4px;
  padding: 10px 28px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.3s;
}

.login-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}

.login-link:hover {
  text-decoration: underline;
}
</style>
